/**
 * WordPress dependencies
 */
import { __, _x } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import edit from './edit';
import icon from './icon';
var metadata = {
  name: "core/more",
  category: "layout",
  attributes: {
    customText: {
      type: "string"
    },
    noTeaser: {
      type: "boolean",
      "default": false
    }
  }
};
import save from './save';
import transforms from './transforms';
var name = metadata.name;
export { metadata, name };
export var settings = {
  title: _x('More', 'block name'),
  description: __('Content before this block will be shown in the excerpt on your archives page.'),
  icon: icon,
  supports: {
    customClassName: false,
    className: false,
    html: false,
    multiple: false
  },
  example: {},
  transforms: transforms,
  edit: edit,
  save: save
};
//# sourceMappingURL=index.js.map